import {isNil} from 'lodash';

import {ExitPopup} from '/component/base/ExitPopup';
import {REPORT_ALL_REFERRALS} from '/enum/records.enum';
import {ACTION_TYPES, EVENT_NAMES, USER_TYPES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
  eventName: EVENT_NAMES.notesEntry,
});
export const handleEditNotes = async ({
  updateNotes,
  id,
  navigation,
  body,
  setState,
  notes,
  userType,
  lastPaidRank,
  coachHighestRank,
  coachCurrentRank,
  coachId,
}: any) => {
  const isReferralNotes = userType === USER_TYPES.candidateReferral;

  if (notes === body.notes) {
    const eventData: any = {
      userType: userType,
      action: ACTION_TYPES.abandon,
      lastPaidRank: lastPaidRank,
    };

    if (isReferralNotes) {
      eventData.report_name = REPORT_ALL_REFERRALS;
      eventData.coach_highest_rank = coachHighestRank;
      eventData.coach_current_rank = coachCurrentRank;
      eventData.coach_id = coachId;
    }

    sendEvent(eventData);
    navigation.goBack();
  } else {
    setState();
    await updateNotes({id, body});

    const action = isNil(notes) ? ACTION_TYPES.new : ACTION_TYPES.edit;
    const eventData: any = {
      userType: userType,
      action: action,
      lastPaidRank: lastPaidRank,
    };

    if (isReferralNotes) {
      eventData.report_name = REPORT_ALL_REFERRALS;
      eventData.coach_highest_rank = coachHighestRank;
      eventData.coach_current_rank = coachCurrentRank;
      eventData.coach_id = coachId;
    }

    sendEvent(eventData);

    setTimeout(() => {
      navigation.goBack();
    }, 100);
  }
};
export const handleBackButton = ({
  notes,
  id: _id,
  body,
  navigation,
  showPopup,
  hidePopup,
  userType,
  lastPaidRank,
  coachHighestRank,
  coachCurrentRank,
  coachId,
}: any) => {
  const isReferralNotes = userType === USER_TYPES.candidateReferral;

  if (notes === body.notes) {
    navigation.goBack();

    const eventData: any = {
      userType: userType,
      action: ACTION_TYPES.abandon,
      lastPaidRank: lastPaidRank,
    };

    if (isReferralNotes) {
      eventData.report_name = REPORT_ALL_REFERRALS;
      eventData.coach_highest_rank = coachHighestRank;
      eventData.coach_current_rank = coachCurrentRank;
      eventData.coach_id = coachId;
    }

    sendEvent(eventData);
  } else {
    showPopup(
      ExitPopup,
      {
        title: 'Are you sure you want to go back?',
        description: 'All unsaved changes will be lost.',
        alignButtonsAsColumn: true,
        handleCancelButton: hidePopup,
        handleDiscardButton: async () => {
          await hidePopup();
          navigation.goBack();

          const eventData: any = {
            user_type: userType,
            action: ACTION_TYPES.abandon,
            last_paid_rank: lastPaidRank,
          };

          if (isReferralNotes) {
            eventData.report_name = REPORT_ALL_REFERRALS;
            eventData.coach_highest_rank = coachHighestRank;
            eventData.coach_current_rank = coachCurrentRank;
            eventData.coach_id = coachId;
          }

          sendEvent(eventData);
        },
        exitButton: hidePopup,
      },
      {avoidable: false, showFullModal: false},
    );
  }
};
